<template lang="html">
  <v-page class="page-terms">
    <v-container>
      <v-row class="justify-content-center">
        <v-col :md="9">
          <v-logo />

          <div class="terms-text" role="article">
            <h1>
              POR FAVOR, PARA PROSSEGUIR COM A UTILIZAÇÃO DA PLATAFORMA VIBBRA,
              É IMPORTANTE QUE VOCÊ LEIA ATENCIOSAMENTE, ENTENDA E CONCORDE COM
              OS TERMOS SEGUINTES.
            </h1>

            <p>Última modificação: 08 de Julho de 2019.</p>

            <p>
              Em caso de discordância do que será disposto abaixo, você deverá
              cessar imediatamente a utilização da Plataforma, bem como qualquer
              outra funcionalidade oferecida pela Vibbra. Sempre que necessário,
              contate a Vibbra através do e-mail <b>suporte@vibbra.com.br</b>.
            </p>

            <p>1.1. Declaro que concordo e tenho pleno conhecimento:</p>

            <p>
              1.1.1. Dos direitos e obrigações decorrentes dos
              <v-link :to="{ name: 'terms' }" target="_blank"
                ><b>Termos e Condições Gerais de Uso</b></v-link
              >, constituindo este instrumento o acordo entre as partes.
              Declaro, ainda, ter lido, compreendido e aceito todos os seus
              termos e condições;
            </p>

            <p>
              1.1.2. Que fui devidamente informado a respeito da
              <v-link :to="{ name: 'privacy' }" target="_blank"
                ><b>Política de Privacidade</b></v-link
              >
              da Vibbra, consentindo livre e expressamente com a referida
              política;
            </p>

            <p>
              1.1.3. Que a utilização dos serviços Vibbra não implica na
              existência de qualquer vínculo empregatício, seja com a empresa
              Vibbra ou qualquer cliente da mesma (Usuários Contratantes), sendo
              a Vibbra e seus clientes isentos, em todas as hipóteses, de
              qualquer obrigação referentes a encargos trabalhistas,
              previdenciários (INSS) ou fundiários (FGTS);
            </p>

            <p>
              1.1.4. Que serei submetido ao teste técnico aplicado pela Vibbra,
              cuja finalidade é compreender o desempenho e o nível técnico dos
              candidatos à Usuário Profissional, a fim de aferir maior qualidade
              dos serviços disponibilizados por meio da Plataforma Vibbra.
            </p>

            <p>
              1.1.5. Que para assegurar o padrão de qualidade Vibbra, meu
              cadastro junto à Plataforma estará sujeito a avaliação, e concordo
              com a hipótese de ter o acesso negado para integrar como Usuário
              Profissional na Plataforma, sem que haja nada a reivindicar
              referente a não efetivação do cadastro;
            </p>

            <p>
              1.1.6. A respeito do
              <v-link :to="{ name: 'manual' }" target="_blank"
                ><b>Manual de Boas Práticas</b></v-link
              >, ao qual declaro, ainda, ter lido e compreendido, e me
              comprometo a segui-lo enquanto usar a Plataforma como Usuário
              Profissional, com a finalidade de sempre resguardar pelo padrão de
              qualidade Vibbra;
            </p>

            <p>
              1.1.7. Que não poderei abordar, negociar e/ou aceitar contratação
              direta de Usuários Contratantes apresentados pela Vibbra, sujeito
              a pena de multa na importância de R$ 100.000,00 (cem mil reais),
              bem como outras penalidades legais aplicáveis, assim como a
              suspensão imediata da Plataforma Vibbra. Havendo esse interesse, é
              necessário contatar a Vibbra para que a mesma então avalie e dê
              seu parecer sobre o caso.
            </p>
          </div>
          <v-divider :size="2" line />
          <v-button
            class="primary btn-block mt-3"
            v-if="showAcceptButton"
            @click="acceptTerm()"
            >Declaro que li e concordo com os termos de aceite da plataforma
            Vibbra</v-button
          >
        </v-col>
      </v-row>
    </v-container>
  </v-page>
</template>

<script>
import apiVibbrante from '@/api/vibbrante';

export default {
  props: {
    showAcceptButton: {
      default: true,
      type: Boolean,
    },
  },
  methods: {
    acceptTerm() {
      apiVibbrante
        .vibbranteAcceptTerm()
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('acceptedTerm');
            this.$router.push({ name: 'vibbrant-dashboard' });
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
  },
};
</script>

<style lang="scss">
.terms-text {
  font-size: 0.9em;
  h1 {
    font-size: 1.8em;
  }
  h2 {
    font-size: 1.6em;
  }
}
.page-terms {
  .logo {
    width: 200px;
    margin: 0 auto 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/accept-vibbrant.vue